import { CryptoCurrency } from '../enums/cryptoCurrency';

export const CRYPTO_CURRENCY_SYMBOLS: { [key in CryptoCurrency]: string } = {
  [CryptoCurrency.Fan]: 'FAN',
  [CryptoCurrency.Bnb]: 'BNB',
  [CryptoCurrency.Matic]: 'MATIC',
};
